import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface TeamTableState {
  selectedTeams: any;
  setSelectedTeams: (selectedTeams: any) => void;
}

export const useTeamTableStore = create<TeamTableState>()(
  persist(
    (set) => ({
      selectedTeams: [],
      setSelectedTeams: (selectedTeams) => set({ selectedTeams }),
    }),
    {
      name: 'team-table-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default useTeamTableStore;
